import styled from '@emotion/styled';
export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ size })=>size === 'sm' ? '0.5rem' : size === 'md' ? '0.75rem' : '1rem'};
  width: 100%;

  @media (max-width: 400px) {
    gap: ${({ size })=>size === 'sm' ? '0.375rem' : '0.5rem'};
  }
  @media (max-width: 350px) {
    gap: ${({ size })=>size === 'sm' ? '0.25rem' : '0.375rem'};
  }
`;
export const ActionButtonWrapper = styled.div`
  position: relative;
`;
// 답글 대상자 텍스트 스타일
export const ReplyToText = styled.div`
  color: var(--theme-text-secondary);
  font-size: 0.875rem;
  margin-top: -0.125rem;
  margin-bottom: 0.25rem;

  @media (max-width: 400px) {
    font-size: 0.8rem;
  }
  @media (max-width: 350px) {
    font-size: 0.75rem;
  }
`;
// 스레드 라인 스타일
export const ThreadLineContainer = styled.div`
  position: relative;
  ${({ hasLine })=>hasLine && `
    &::before {
      content: '';
      position: absolute;
      left: 50%;
      top: -20px;
      width: 2px;
      height: 20px;
      background-color: var(--theme-border);
      transform: translateX(-50%);
    }
  `}
`;
export const ThreadLineBottom = styled.div`
  position: absolute;
  left: 50%;
  top: 100%;
  width: 2px;
  height: ${({ height })=>height};
  background-color: var(--theme-border);
  transform: translateX(-50%);
  transition: height 0.3s ease-out;
`;
// 리트윗 표시 스타일
export const RetweetIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--theme-text-secondary);
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  padding-left: 2.5rem;

  @media (max-width: 400px) {
    font-size: 0.8rem;
    padding-left: 2rem;
  }
  @media (max-width: 350px) {
    font-size: 0.75rem;
    padding-left: 1.75rem;
  }
`;
// 메인 헤더 컨테이너
export const HeaderWrapper = styled.div`
  position: relative;
  width: 100%;
`;
// 컨텐츠 영역
export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
`;
// 헤더 정보 영역
export const HeaderInfo = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;
